namespace Matrix.Workflow {
    export interface ApprovalForm {
        QueueCode: FormatLookupEditor;
        EntityType: Serenity.LookupEditor;
        RecordKey: Serenity.StringEditor;
        OperationCode: Serenity.StringEditor;
        CreatedBy: Serenity.StringEditor;
        CreatedWhen: ReadOnlyDateTime;
        StatusCode: Serenity.StringEditor;
        StatusDescription: Serenity.StringEditor;
        UpdatedBy: Serenity.StringEditor;
        UpdatedWhen: ReadOnlyDateTime;
        Comment: Serenity.StringEditor;
        ApproveRejectComment: Serenity.StringEditor;
        DiffView: DiffView;
    }

    export class ApprovalForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.Approval';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApprovalForm.init)  {
                ApprovalForm.init = true;

                var s = Serenity;
                var w0 = FormatLookupEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = ReadOnlyDateTime;
                var w4 = DiffView;

                Q.initFormType(ApprovalForm, [
                    'QueueCode', w0,
                    'EntityType', w1,
                    'RecordKey', w2,
                    'OperationCode', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'StatusCode', w2,
                    'StatusDescription', w2,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Comment', w2,
                    'ApproveRejectComment', w2,
                    'DiffView', w4
                ]);
            }
        }
    }
}
